/* eslint-disable */
import changeCase from 'change-object-case';
import moment from 'moment';
import React, { Component } from 'react';
import { Helmet } from "react-helmet";
import { Link } from 'react-router';
import { connect } from 'react-redux'
import { mapDispatch, navTo, numberWithCommas } from '../utils/util';
import { Button, Form, Glyphicon, FormGroup, ControlLabel, FormControl, Table, Modal } from 'react-bootstrap';
import { DateRangePicker, SingleDatePicker, DayPickerRangeController } from 'react-dates';
import FontAwesome from 'react-fontawesome';

import OzComponent from '../lib/OzComponent';
import Wrapper from './Wrapper';
import RoomList from './partials/RoomList';
import Sharing from './partials/Sharing';
import './PlayAtHome.css';

import {
} from '../actions';


class PlayAtHome extends OzComponent {

  static need = [
  ];

  state = {};

  componentDidMount() {
    try {
      scroll(0, 0);
    } catch (e) {}
  }
  render() {
    return (
      <Wrapper className="PlayAtHome" title="Play-At-Home Escape Games">
        <Helmet>
          <title>Play-At-Home Escape Games - EscapeSpy</title>
        </Helmet>

        <div className="content-padded">
          <p><b>Looking to for a new experience during lockdown?</b> Then play-at-home escape games are what you're looking for!</p>
          <p>Escape games are immersive puzzle games where you try to solve puzzles in a scenario in a given amount of time, usually an hour. They can be played by yourself, or a group of friends.</p>
          <p>These play-at-home games can all be played in the comfort of your own home. Get a group of friends and family, either from your home or over a video chat, and crack the puzzles together. When you're done, add a review below to share your experience.</p>

          <Sharing url="https://www.escapespy.com/play-at-home" />
        </div>

        <RoomList
          params={{ pah: 1, limit: 100 }}
        />

        <br/>

      </Wrapper>
    );
  }
}

function mapStateToProps(state) {
  return {
  };
}

function mapDispatchToProps(dispatch) {
  return mapDispatch(dispatch, {
  });
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PlayAtHome);



/** WEBPACK FOOTER **
 ** ./src/components/PlayAtHome.js
 **/